import { createContext, useContext, Dispatch, SetStateAction } from 'react'

export interface GlobalContextValue {
  // routing/view mode
  viewMode: string

  // access control
  accessDeniedMode: boolean
  setAccessDeniedMode: Dispatch<SetStateAction<boolean>>

  // agent selection
  selectedAgentName: string | null
  selectedAgentEmail: string | null
  setSelectedAgentName: Dispatch<SetStateAction<string | null>>
  setSelectedAgentEmail: Dispatch<SetStateAction<string | null>>

  // organisations
  showChangeOrganisation: boolean
  allOrganisations: any[]
  currentOrganisation: any | null
  setCurrentOrganisation: Dispatch<SetStateAction<any | null>>

  // export/questions state
  exportedQuestions: any | null
  setExportQuestions: Dispatch<SetStateAction<any | null>>

  // sessions data
  sessionsData: any[]
  setSessionsData: Dispatch<SetStateAction<any[]>>

  // header text
  headerText: string | null
  setHeaderText: Dispatch<SetStateAction<string | null>>
}

const defaultGlobalContextValue: GlobalContextValue = {
  viewMode: '',

  accessDeniedMode: false,
  setAccessDeniedMode: () => {},

  selectedAgentName: '',
  selectedAgentEmail: '',
  setSelectedAgentName: () => {},
  setSelectedAgentEmail: () => {},

  showChangeOrganisation: false,
  allOrganisations: [],
  currentOrganisation: null,
  setCurrentOrganisation: () => {},

  exportedQuestions: null,
  setExportQuestions: () => {},

  sessionsData: [],
  setSessionsData: () => {},

  headerText: null,
  setHeaderText: () => {},
}

export const GlobalContext = createContext<GlobalContextValue>(
  defaultGlobalContextValue,
)

export function useGlobalContext(): GlobalContextValue {
  return useContext(GlobalContext)
}
